const ENV = process.env.REACT_APP_ENV || 'dev';

const companyNewViewByEnv = {
  dev: [ 824, 1068, 1244, 1639 ],
  staging: [ 824, 1068, 1244, 1629, 1639 ],
  prod: [ 824, 1068, 1244, 774, 1639 ]
};

// Prod
// 824 Media Shake
// 1068 Publimovil Agency ES
// 1244 Growthing
// 774 CLARO MEDIA CO
// 1639 LatinAd Agencia Demo

const userNewViewByEnv = {
  dev: [ 1900, 1528, 3123, 3754, 2911, 3491, 3848, 3700, 3701, 3702 , 63 ],
  staging: [ 1900, 1528, 3123, 3754, 2911, 3491, 3848, 3700, 3701, 3702 , 63, 3869 ],
  prod: [ 1900, 1528, 3123, 3754, 2911, 3491, 3848, 3700, 3701, 3702 , 63 ]
};
// PROD
// 3848 is advertiser in dev/stagin/prod
// 1900	raul.tobon@ladorian.com
// 1528	leandrodahlmann@gmail.com
// 3123	Liggia.aguirre@grupopublimovil.com
// 3754	Andrea.Aguilar
// 2911	eduardo.escalante@grupopublimovil.com
// 3491	ricardoaguilar
// 3700 lcardona@link-factor.com
// 3701 ehernandez@link-factor.com
// 3702 amonsalve@link-factor.com
// 63 pabloga90@gmail.com
// TODO: // 807	rruiz@omg.cr

export const companyNewView = companyNewViewByEnv[ENV];
export const userNewView = userNewViewByEnv[ENV];

export const urlTutorial = "https://www.youtube.com/embed/anE6g89v624?autoplay=1"